/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfOrderWithInvoiceNumbersDtoFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type PagedResultOfOrderWithInvoiceNumbersDto } from '../../models/index.js';
// @ts-ignore
import { BackfillSalesrepSnapshotsRequestBuilderRequestsMetadata, type BackfillSalesrepSnapshotsRequestBuilder } from './backfillSalesrepSnapshots/index.js';
// @ts-ignore
import { BatchesRequestBuilderNavigationMetadata, type BatchesRequestBuilder } from './batches/index.js';
// @ts-ignore
import { BulkRequestBuilderRequestsMetadata, type BulkRequestBuilder } from './bulk/index.js';
// @ts-ignore
import { ByCustomerRequestBuilderNavigationMetadata, type ByCustomerRequestBuilder } from './byCustomer/index.js';
// @ts-ignore
import { ExportedRequestBuilderRequestsMetadata, type ExportedRequestBuilder } from './exported/index.js';
// @ts-ignore
import { ItemRequestBuilderNavigationMetadata, ItemRequestBuilderRequestsMetadata, type ItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { PublicRequestBuilderNavigationMetadata, type PublicRequestBuilder } from './public/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/orders
 */
export interface OrdersRequestBuilder extends BaseRequestBuilder<OrdersRequestBuilder> {
    /**
     * The backfillSalesrepSnapshots property
     */
    get backfillSalesrepSnapshots(): BackfillSalesrepSnapshotsRequestBuilder;
    /**
     * The batches property
     */
    get batches(): BatchesRequestBuilder;
    /**
     * The bulk property
     */
    get bulk(): BulkRequestBuilder;
    /**
     * The byCustomer property
     */
    get byCustomer(): ByCustomerRequestBuilder;
    /**
     * The exported property
     */
    get exported(): ExportedRequestBuilder;
    /**
     * The public property
     */
    get public(): PublicRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.orders.item collection
     * @param id Unique identifier of the item
     * @returns {ItemRequestBuilder}
     */
     byId(id: string) : ItemRequestBuilder;
    /**
     * Returns a paginated list of orders, each paired with the invoice numbers of invoices generated against that order.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfOrderWithInvoiceNumbersDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<OrdersRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfOrderWithInvoiceNumbersDto | undefined>;
    /**
     * Returns a paginated list of orders, each paired with the invoice numbers of invoices generated against that order.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<OrdersRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns a paginated list of orders, each paired with the invoice numbers of invoices generated against that order.
 */
export interface OrdersRequestBuilderGetQueryParameters {
    /**
     * Gets or sets the filters for the request, this is optionalAcceptable operators are: starts with, contains, notcontains, endswith, equals, notequals, gt, get, lt, lte
     */
    filters?: string[];
    /**
     * Gets or sets the page number for the request. Default value is 1.
     */
    pageNumber?: number;
    /**
     * Gets or sets the page size for the request. Default value is 25.
     */
    pageSize?: number;
    /**
     * Gets or sets the sort direction. Can be "ASC" or "DESC". Default value is "asc".
     */
    sortDirection?: string;
    /**
     * Gets or sets the field to sort on. Default value is "Name".
     */
    sortOn?: string;
}
/**
 * Uri template for the request builder.
 */
export const OrdersRequestBuilderUriTemplate = "{+baseurl}/api/orders?filters={filters}&pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrdersRequestBuilderNavigationMetadata: Record<Exclude<keyof OrdersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: ItemRequestBuilderRequestsMetadata,
        navigationMetadata: ItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["%2Did"],
    },
    backfillSalesrepSnapshots: {
        requestsMetadata: BackfillSalesrepSnapshotsRequestBuilderRequestsMetadata,
    },
    batches: {
        navigationMetadata: BatchesRequestBuilderNavigationMetadata,
    },
    bulk: {
        requestsMetadata: BulkRequestBuilderRequestsMetadata,
    },
    byCustomer: {
        navigationMetadata: ByCustomerRequestBuilderNavigationMetadata,
    },
    exported: {
        requestsMetadata: ExportedRequestBuilderRequestsMetadata,
    },
    public: {
        navigationMetadata: PublicRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const OrdersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: OrdersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfOrderWithInvoiceNumbersDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
